<template>
  <div class="w-100">
    <RoomCart v-if="cartPageType === 'ROOM'" />
    <AdditionalCart v-else />
  </div>
</template>

<script>
  import RoomCart from './BeCart.vue';
  import AdditionalCart from './BeCartAdditional.vue';
  import { mapGetters } from 'vuex';
  
  export default {
    components:{
      RoomCart,
      AdditionalCart
    },
    computed: {
      ...mapGetters(['getBeRoomSubTotal']),
      cartPageType(){
        return this.getBeRoomSubTotal > 0 ? 'ROOM' : 'ADDITIONAL';
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeCartBase.vue